import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { cn } from '@/shared/lib/utils';

type DropdownMenuItemProps = React.ComponentProps<typeof DropdownMenuPrimitive.Item> & {
  inset?: boolean;
};

export const DropdownMenuItem = ({
  className,
  inset,
  onClick,
  disabled,
  ...props
}: DropdownMenuItemProps) => (
  <DropdownMenuPrimitive.Item
    className={cn(
      'relative flex select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-secondary/80',
      disabled
        ? 'pointer-events-none opacity-50'
        : onClick
          ? 'cursor-pointer hover:bg-stone-50'
          : '',
      inset && 'pl-8',
      className,
    )}
    onClick={onClick}
    disabled={disabled}
    {...props}
  />
);
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
